var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBit5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 354.3 168.7",
    style: {
      enableBackground: "new 0 0 354.3 168.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9172FF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.1,168.7c35.3,0,64.2-28.2,65.2-63.3h0v-1.9V49c0,0,0,0,0,0V23.2c0,0,0,0,0,0v-0.7h-0.8 C335.8,8.4,313.4,0,289.1,0c-24.7,0-47.4,8.7-65.2,23.2V31v18v54.5C223.9,139.4,253.1,168.7,289.1,168.7z M279.2,19 c3.2-0.4,6.5-0.6,9.9-0.6c17.3,0,33.3,5.2,46.8,14.1v25.6c-11.9-12.2-28.4-19.8-46.8-19.8c-3.4,0-6.7,0.3-9.9,0.7V19z M242.3,58.1 v-23v-2.6c5.7-3.8,11.9-6.9,18.4-9.2v11.8v9.7v8.6v13c7.9-6,17.7-9.6,28.3-9.6c25.8,0,46.8,21,46.8,46.8s-21,46.8-46.8,46.8 c-22.6,0-41.6-16.2-45.9-37.5h18.4c3.9,11.5,14.7,19.7,27.4,19.7c16,0,28.9-13,28.9-28.9s-13-28.9-28.9-28.9 c-12.8,0-23.6,8.3-27.4,19.7h-0.9h-17.5h-0.9V58.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72,81.5l-1.8-1.3l1.6-1.6c2.5-2.6,4.5-5.7,5.9-9.2c1.5-3.5,2.2-7.1,2.2-10.8v-9.9c0-4.2-0.7-8.1-2-11.6 c-1.3-3.5-3.2-6.5-5.6-8.9c-2.4-2.4-5.3-4.4-8.6-5.7c-3.4-1.3-7.1-2-11.2-2h-6.1v18.4h2.3c1.9,0,3.7,0.4,5.4,1.3 c1.7,0.8,3.2,2,4.5,3.4c1.3,1.4,2.3,3.1,3,4.9c0.7,1.8,1,3.8,1,6v1.8c0,2-0.3,4-1,5.8c-0.7,1.9-1.7,3.5-3,4.9 c-1.3,1.4-2.8,2.5-4.4,3.3c-1.7,0.9-3.5,1.3-5.4,1.3H17.3V38.9h16.2V20.4H0v119.1h33.5v-18.8H17.3V88.6H50c1.9,0,3.7,0.4,5.5,1.3 c1.7,0.8,3.3,2,4.5,3.4c1.2,1.4,2.2,3,3,4.8c0.8,1.9,1.1,3.9,1.1,5.9v1.3c0,2.2-0.4,4.2-1.1,6.1c-0.8,1.8-1.8,3.5-3,4.8 c-1.3,1.4-2.8,2.5-4.5,3.4c-1.8,0.9-3.6,1.3-5.5,1.3h-3.7v18.8H54c4.1,0,7.8-0.7,11.1-2c3.3-1.3,6.1-3.3,8.5-5.8 c2.4-2.6,4.3-5.8,5.6-9.6c1.4-3.9,2.1-8.3,2.1-13.1v-7.6c0-3.8-0.7-7.5-2.2-11.1C77.7,86.9,75.3,83.9,72,81.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "103.2,52.4 103.4,139.5 120.7,139.5 120.5,52.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.4,
    y: 20.4,
    className: "st0",
    width: 17.3,
    height: 17.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 81.8,
    className: "st1",
    width: 17.3,
    height: 57.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "177.1,51.5 177.1,20.4 159.8,20.4 159.8,51.5 142.8,51.5 142.8,68.3 194.1,68.3 194.1,51.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit5);
export default __webpack_public_path__ + "static/media/bit5.d650f790c6ea527cc45522dbb35df1e9.svg";
export { ForwardRef as ReactComponent };